import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

export const updateWalletBalance = async (walletData) => {
  try {
    const response = await api.post(
      `${API_URL}/transaction/wallet_update`,
      walletData
    );
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};
